import { render, staticRenderFns } from "./SundryCreditorNew.vue?vue&type=template&id=65464cb2"
import script from "./SundryCreditorNew.vue?vue&type=script&lang=js"
export * from "./SundryCreditorNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports